<template>
    <div>
        <v-layout wrap align-center>
            <div class="az-text ml-3 mr-2">
                <label>Tipo:</label>
            </div>

            <v-flex xs12 sm2 d-flex pt-4>
                <v-select
                    label="Selecione"
                    v-model="loteSelecionado"
                    :items="lotes"
                    item-text="descricao"
                    item-value="id"
                    dense
                    @change="buscarFornecedores"
                ></v-select>
            </v-flex>

            <div class="az-text ml-3 mr-2">
                <label>Fornecedor:</label>
            </div>

            <v-flex xs12 sm2 d-flex pt-4>
                <v-select
                    label="Selecione"
                    v-model="fornecedorSelecionado"
                    :items="fornecedores"
                    item-text="razaoSocial"
                    item-value="id"
                    dense
                ></v-select>
            </v-flex>

            <v-flex xs12 sm3 d-flex>
                <v-btn
                    outlined
                    @click="visualizarDocumentos"
                    :disabled="!loteSelecionado || !fornecedorSelecionado"
                >
                    Visualizar Documentos
                </v-btn>
            </v-flex>

            <v-flex xs12 sm12 d-flex v-if="existeDocumentos">
                <span class="az-subtitle primary--text">Documentos</span>
            </v-flex>

            <v-flex xs12>
                <div class="az-text" v-if="existeDocumentos">
                    <ul>
                        <li v-for="documento in documentos" :key="documento.id">
                            <a :href="documento.url" class="az-action-link-icon" target="_blank" @click.prevent="downloadAnexo(documento)">
                                {{ documento.nome }}
                                <v-icon size="20px">download</v-icon>
                            </a>
                        </li>
                    </ul>
                </div>
            </v-flex>
        </v-layout>
        <v-spacer style="height: 20px;"></v-spacer>
    </div>
</template>

<script>
import {mapActions} from "vuex";
import {actionTypes} from "@/commons/constants";

export default {
    name: 'DetalheDocumentosFornecedorDadosGerais',
    props: {
        lotes: {
            required: true
        },
        fornecedores: {
            required: true
        },
        documentos: {
            required: true
        }
    },
    data() {
        return {
            loteSelecionado: null,
            fornecedorSelecionado: null,
        };
    },
    computed: {
        existeDocumentos() {
            return Array.isArray(this.documentos) && this.documentos.length > 0
        }
    },
    methods: {
        async buscarFornecedores() {
            await this.$emit('buscarFornecedores', this.loteSelecionado)
        },
        async visualizarDocumentos() {
            await this.$emit('buscarDocumentosFornecedor', this.loteSelecionado, this.fornecedorSelecionado)
        },
        async downloadAnexo(documento) {
            console.log(documento)
            await this.downloadAnexoDocFornecedorUsiga({
                idAnexo: documento.id,
                nomeAnexo: documento.nome
            })
        },
        ...mapActions({
            downloadAnexoDocFornecedorUsiga: actionTypes.DOWNLOAD_ANEXO_DOC_FORNECEDOR
        })
    }
};
</script>